var _path, _rect, _rect2, _path2, _circle, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWalletLogo = function SvgWalletLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.742 7.484 33.386.896a3.314 3.314 0 0 1 4.033 3.236v50.554A3.314 3.314 0 0 1 34.105 58H8.713a4.971 4.971 0 0 1-4.971-4.971V7.484Z",
    fill: "#1560FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7.352,
    width: 58,
    height: 50.648,
    rx: 4.677,
    fill: "url(#wallet-logo_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5.613,
    y: 13.097,
    width: 46.774,
    height: 39.29,
    rx: 4.677,
    stroke: "#000",
    strokeWidth: 0.415
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.143 30.078a3.564 3.564 0 0 1 3.563-3.564H58v13.257H36.706a3.564 3.564 0 0 1-3.563-3.563v-6.13Z",
    fill: "#1560FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.771,
    cy: 33.143,
    r: 4.143,
    stroke: "#29EFE8",
    strokeWidth: 1.657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.742,
    y: 18.71,
    width: 3.742,
    height: 9.355,
    rx: 1.871,
    fill: "#29EFE8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.742,
    y: 37.419,
    width: 3.742,
    height: 9.355,
    rx: 1.871,
    fill: "#29EFE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet-logo_svg__a",
    x1: 29,
    y1: 7.352,
    x2: 29,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1560FA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWalletLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1OCA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy43NDIgNy40ODQgMzMuMzg2Ljg5NmEzLjMxNCAzLjMxNCAwIDAgMSA0LjAzMyAzLjIzNnY1MC41NTRBMy4zMTQgMy4zMTQgMCAwIDEgMzQuMTA1IDU4SDguNzEzYTQuOTcxIDQuOTcxIDAgMCAxLTQuOTcxLTQuOTcxVjcuNDg0WiIgZmlsbD0iIzE1NjBGQSIvPjxyZWN0IHk9IjcuMzUyIiB3aWR0aD0iNTgiIGhlaWdodD0iNTAuNjQ4IiByeD0iNC42NzciIGZpbGw9InVybCgjd2FsbGV0LWxvZ29fc3ZnX19hKSIvPjxyZWN0IG9wYWNpdHk9Ii4zIiB4PSI1LjYxMyIgeT0iMTMuMDk3IiB3aWR0aD0iNDYuNzc0IiBoZWlnaHQ9IjM5LjI5IiByeD0iNC42NzciIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIuNDE1Ii8+PHBhdGggZD0iTTMzLjE0MyAzMC4wNzhhMy41NjQgMy41NjQgMCAwIDEgMy41NjMtMy41NjRINTh2MTMuMjU3SDM2LjcwNmEzLjU2NCAzLjU2NCAwIDAgMS0zLjU2My0zLjU2M3YtNi4xM1oiIGZpbGw9IiMxNTYwRkEiLz48Y2lyY2xlIGN4PSIzOS43NzEiIGN5PSIzMy4xNDMiIHI9IjQuMTQzIiBzdHJva2U9IiMyOUVGRTgiIHN0cm9rZS13aWR0aD0iMS42NTciLz48cmVjdCB4PSIzLjc0MiIgeT0iMTguNzEiIHdpZHRoPSIzLjc0MiIgaGVpZ2h0PSI5LjM1NSIgcng9IjEuODcxIiBmaWxsPSIjMjlFRkU4Ii8+PHJlY3QgeD0iMy43NDIiIHk9IjM3LjQxOSIgd2lkdGg9IjMuNzQyIiBoZWlnaHQ9IjkuMzU1IiByeD0iMS44NzEiIGZpbGw9IiMyOUVGRTgiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9IndhbGxldC1sb2dvX3N2Z19fYSIgeDE9IjI5IiB5MT0iNy4zNTIiIHgyPSIyOSIgeTI9IjU4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iIzBBOURGRiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE1NjBGQSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjwvc3ZnPg==";